// Colors For Charts and stats
export const BASE_COLORS = [
  "#F49102",
  "#F6B642",
  "#F9D77D",
  "#D98E04",
  "#A55E01",
  "#F3B56C",
  "#F2A20C",
  "#FFB84D",
  "#E68A00",
  "#C76D00",
  "#A65A00",
  "#FFD699",
  "#FFCC66",
  "#FFB84A",
];